var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _g4, _path9, _g5, _g6, _path0, _path1, _g7, _path10, _path11, _g8, _path12, _g9, _path13, _g0, _g1, _path14, _path15, _g10, _path16, _path17, _g11, _path18, _path19, _g12, _path20, _path21, _g13, _path22, _path23, _g14, _path24, _path25, _g15, _path26, _g16, _path27, _g17, _path28, _g18, _path29, _g19, _g20, _path30, _g21, _path31, _g22, _g23, _path32, _path33, _g24, _path34, _g25, _path35, _g26, _g27, _path36, _path37, _g28, _path38, _g29, _path39, _g30, _g31, _path40, _path41, _g32, _path42, _g33, _path43, _g34, _path44, _g35, _g36, _path45, _g37, _path46, _g38, _g39, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g40, _path66, _path67, _g41, _path68, _g42, _path69, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZebraHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_189850)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.03 320.001C213.618 320.001 257.059 314.111 257.059 306.845C257.059 299.579 213.618 293.689 160.03 293.689C106.442 293.689 63 299.579 63 306.845C63 314.111 106.442 320.001 160.03 320.001Z",
    fill: "#F0BA9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.671 254.163C218.283 254.992 210.824 252.859 203.957 247.703C198.747 243.733 193.893 237.985 190.518 230.281L183.77 233.659C188.032 242.548 193.952 249.007 200.227 253.392C208.871 259.378 218.106 261.333 224.618 260.089L223.671 254.163Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 230,
    width: 42,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.671 254.163C218.283 254.992 210.824 252.859 203.957 247.703C198.747 243.733 193.893 237.985 190.518 230.281L183.77 233.659C188.032 242.548 193.952 249.007 200.227 253.392C208.871 259.378 218.106 261.333 224.618 260.089L223.671 254.163Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.205 237.629C188.804 240.355 191.408 242.844 193.599 245.036C199.637 251.081 206.741 255.466 214.852 257.481C217.042 258.014 219.292 258.666 221.601 258.725C221.778 258.725 222.252 259.318 222.37 259.436C223.081 260.029 223.791 260.503 224.561 260.918C226.81 262.162 229.237 262.755 231.783 262.636C237.23 262.459 241.729 259.318 245.281 255.17C246.465 253.807 247.59 252.384 248.714 250.903C249.129 250.31 249.602 249.659 250.017 249.066C250.076 249.007 250.372 248.533 250.49 248.651C250.727 248.947 250.194 249.955 250.076 250.251C249.425 251.97 248.655 253.57 247.767 255.17C244.097 261.688 238.295 266.607 230.895 267.259C227.58 267.555 224.205 267.021 221.186 265.659C219.588 264.947 218.167 263.703 216.569 263.051C213.727 261.984 210.648 261.866 207.807 260.74C198.868 257.125 190.402 250.192 185.488 241.54L187.205 237.629Z",
    fill: "#D0D0D0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.341 263.704C220 265.186 215.501 257.6 220.651 252.8C225.151 248.593 233.794 254.46 237.405 245.097C238.53 246.341 238.352 249.304 236.872 251.497C236.872 251.497 238.234 250.667 238.944 248.652C239.24 250.193 239.063 251.911 237.642 254.341C237.642 254.341 238.944 253.689 239.892 253.986C235.451 255.467 235.925 261.986 227.341 263.704Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 245,
    width: 22,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.341 263.704C220 265.186 215.501 257.6 220.651 252.8C225.151 248.593 233.794 254.46 237.405 245.097C238.53 246.341 238.352 249.304 236.872 251.497C236.872 251.497 238.234 250.667 238.944 248.652C239.24 250.193 239.063 251.911 237.642 254.341C237.642 254.341 238.944 253.689 239.892 253.986C235.451 255.467 235.925 261.986 227.341 263.704Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.789 260.386L217.867 257.897C222.9 261.749 230.892 259.616 234.621 254.816L232.312 255.468C235.687 252.801 237.522 249.364 238.232 247.053C238.647 245.69 241.607 256.356 240.719 257.423C237.167 262.045 231.957 265.245 225.978 265.008C223.314 264.89 220.65 264.179 218.341 262.816C217.039 262.164 214.789 260.386 214.789 260.386Z",
    fill: "#0D0B0A"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.019 305.837C149.019 305.837 148.368 268.859 154.88 250.015L115.985 236.622C107.875 260.148 107.875 306.192 107.875 306.192L149.019 305.837Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 236,
    width: 48,
    height: 71
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.019 305.837C149.019 305.837 148.368 268.859 154.88 250.015L115.985 236.622C107.875 260.148 107.875 306.192 107.875 306.192L149.019 305.837Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.789 306.133C113.025 293.926 114.269 260.148 120.84 241.126L154.051 252.563C154.288 251.674 154.584 250.844 154.88 250.015L115.985 236.622C107.875 260.148 107.875 306.192 107.875 306.192L112.789 306.133Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 236,
    width: 48,
    height: 71
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.019 305.837C149.019 305.837 148.368 268.859 154.88 250.015L115.985 236.622C107.875 260.148 107.875 306.192 107.875 306.192L149.019 305.837Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.105 272.829C98.6393 273.363 91.8904 275.022 91.9496 276.563C92.068 278.103 98.9945 278.992 107.46 278.459C115.926 277.926 122.675 276.266 122.615 274.726C122.497 273.126 115.571 272.296 107.105 272.829ZM109.177 259.792C101.066 257.363 94.14 256.533 93.6664 258.074C93.1928 259.555 99.4089 262.755 107.519 265.244C115.63 267.674 122.556 268.503 123.03 266.963C123.503 265.481 117.287 262.222 109.177 259.792Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 257,
    width: 17,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 257,
    width: 33,
    height: 22
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.105 272.829C98.6393 273.363 91.8904 275.022 91.9496 276.563C92.068 278.103 98.9945 278.992 107.46 278.459C115.926 277.926 122.675 276.266 122.615 274.726C122.497 273.126 115.571 272.296 107.105 272.829ZM109.177 259.792C101.066 257.363 94.14 256.533 93.6664 258.074C93.1928 259.555 99.4089 262.755 107.519 265.244C115.63 267.674 122.556 268.503 123.03 266.963C123.503 265.481 117.287 262.222 109.177 259.792Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.019 305.837C149.019 305.837 148.368 268.859 154.88 250.015L115.985 236.622C107.875 260.148 107.875 306.192 107.875 306.192L149.019 305.837Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.848 306.133C113.085 293.926 114.328 260.148 120.899 241.126L154.111 252.563C154.347 251.674 154.643 250.844 154.939 250.015L116.045 236.622C107.875 260.148 107.875 306.192 107.875 306.192L112.848 306.133Z",
    fill: "#666460"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.467 306.963C107.697 306.963 106.987 306.548 106.573 305.897C106.158 305.245 106.158 304.415 106.513 303.704C110.184 297.245 120.011 292.504 130.016 292.504C140.317 292.504 147.717 297.482 150.44 304.237C150.677 304.83 150.618 305.541 150.262 306.074C149.907 306.608 149.315 306.904 148.664 306.904C140.731 306.963 117.051 306.963 108.467 306.963Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 292,
    width: 45,
    height: 15
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M108.467 306.963C107.697 306.963 106.987 306.548 106.573 305.897C106.158 305.245 106.158 304.415 106.513 303.704C110.184 297.245 120.011 292.504 130.016 292.504C140.317 292.504 147.717 297.482 150.44 304.237C150.677 304.83 150.618 305.541 150.262 306.074C149.907 306.608 149.315 306.904 148.664 306.904C140.731 306.963 117.051 306.963 108.467 306.963Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.914 301.689C105.447 302.519 106.394 303.052 107.459 303.052C117.524 303.052 141.026 303.052 150.202 302.993C151.031 302.993 151.801 302.638 152.274 301.986C152.57 302.401 152.807 302.815 153.044 303.23C153.458 304.001 153.458 304.949 152.985 305.719C152.511 306.489 151.682 306.964 150.735 306.964C141.322 307.023 117.05 307.023 106.749 307.023C105.624 307.023 104.559 306.371 104.085 305.423C103.552 304.415 103.671 303.289 104.381 302.401C104.559 302.104 104.736 301.926 104.914 301.689Z",
    fill: "#0D0B0A"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.982 305.837C170.982 305.837 171.633 268.859 165.121 250.015L204.016 236.622C212.067 260.148 212.126 306.192 212.126 306.192L170.982 305.837Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 236,
    width: 48,
    height: 71
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.982 305.837C170.982 305.837 171.633 268.859 165.121 250.015L204.016 236.622C212.067 260.148 212.126 306.192 212.126 306.192L170.982 305.837Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.213 306.133C206.976 293.926 205.733 260.148 199.161 241.126L165.95 252.563C165.713 251.674 165.417 250.844 165.121 250.015L204.016 236.622C212.067 260.148 212.126 306.192 212.126 306.192L207.213 306.133Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 236,
    width: 48,
    height: 71
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.982 305.837C170.982 305.837 171.633 268.859 165.121 250.015L204.016 236.622C212.067 260.148 212.126 306.192 212.126 306.192L170.982 305.837Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.895 272.829C221.361 273.363 228.11 275.022 228.05 276.563C227.932 278.103 221.005 278.992 212.54 278.459C204.074 277.926 197.325 276.266 197.384 274.726C197.503 273.126 204.429 272.296 212.895 272.829ZM210.882 259.792C218.993 257.363 225.919 256.533 226.393 258.074C226.866 259.555 220.65 262.755 212.54 265.244C204.429 267.674 197.503 268.503 197.029 266.963C196.556 265.481 202.772 262.222 210.882 259.792Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 257,
    width: 16,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 257,
    width: 32,
    height: 22
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M212.895 272.829C221.361 273.363 228.11 275.022 228.05 276.563C227.932 278.103 221.005 278.992 212.54 278.459C204.074 277.926 197.325 276.266 197.384 274.726C197.503 273.126 204.429 272.296 212.895 272.829ZM210.882 259.792C218.993 257.363 225.919 256.533 226.393 258.074C226.866 259.555 220.65 262.755 212.54 265.244C204.429 267.674 197.503 268.503 197.029 266.963C196.556 265.481 202.772 262.222 210.882 259.792Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.982 305.837C170.982 305.837 171.633 268.859 165.121 250.015L204.016 236.622C212.067 260.148 212.126 306.192 212.126 306.192L170.982 305.837Z",
    fill: "white"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.213 306.133C206.976 293.926 205.733 260.148 199.161 241.126L165.95 252.563C165.713 251.674 165.417 250.844 165.121 250.015L204.016 236.622C212.067 260.148 212.126 306.192 212.126 306.192L207.213 306.133Z",
    fill: "#0D0B0A"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.533 306.963C212.303 306.963 213.013 306.548 213.428 305.897C213.842 305.245 213.842 304.415 213.487 303.704C209.816 297.245 199.989 292.504 189.984 292.504C179.683 292.504 172.283 297.482 169.56 304.237C169.323 304.83 169.382 305.541 169.738 306.074C170.093 306.608 170.685 306.904 171.336 306.904C179.328 306.963 202.949 306.963 211.533 306.963Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 292,
    width: 45,
    height: 15
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M211.533 306.963C212.303 306.963 213.013 306.548 213.428 305.897C213.842 305.245 213.842 304.415 213.487 303.704C209.816 297.245 199.989 292.504 189.984 292.504C179.683 292.504 172.283 297.482 169.56 304.237C169.323 304.83 169.382 305.541 169.738 306.074C170.093 306.608 170.685 306.904 171.336 306.904C179.328 306.963 202.949 306.963 211.533 306.963Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.086 301.689C214.553 302.519 213.606 303.052 212.54 303.052C202.476 303.052 178.974 303.052 169.798 302.993C168.969 302.993 168.199 302.638 167.726 301.986C167.43 302.401 167.193 302.815 166.956 303.23C166.542 304.001 166.542 304.949 167.015 305.719C167.489 306.489 168.318 306.964 169.265 306.964C178.678 307.023 202.95 307.023 213.251 307.023C214.376 307.023 215.441 306.371 215.915 305.423C216.448 304.415 216.27 303.289 215.619 302.401C215.501 302.104 215.264 301.926 215.086 301.689Z",
    fill: "#0D0B0A"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.482 221.749C101.482 221.749 129.188 183.052 144.343 172.8L133.036 156.919C116.341 168.237 85.3203 210.608 85.3203 210.608L101.482 221.749Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 156,
    width: 60,
    height: 66
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.482 221.749C101.482 221.749 129.188 183.052 144.343 172.8L133.036 156.919C116.341 168.237 85.3203 210.608 85.3203 210.608L101.482 221.749Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.092 227.319C105.092 227.319 142.744 181.571 157.84 171.378L149.078 162.489C132.384 173.749 96.8633 220.445 96.8633 220.445L105.092 227.319Z",
    fill: "#D0D0D0"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6128 210.37C71.1679 218.192 71.4639 238.163 84.9024 237.511C89.5793 237.274 95.0849 231.229 96.8017 226.785C96.7425 228.563 97.5121 233.007 100.235 231.526C101.301 230.933 102.544 226.548 101.715 221.392C98.1042 216 90.7633 210.429 85.6128 210.37Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 210,
    width: 28,
    height: 28
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6128 210.37C71.1679 218.192 71.4639 238.163 84.9024 237.511C89.5793 237.274 95.0849 231.229 96.8017 226.785C96.7425 228.563 97.5121 233.007 100.235 231.526C101.301 230.933 102.544 226.548 101.715 221.392C98.1042 216 90.7633 210.429 85.6128 210.37Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.645 216.77C99.7634 216.652 95.6786 220.622 94.4354 223.881C89.5809 235.615 78.1552 240.118 73.3008 227.318C73.8928 238.281 85.2001 242.429 91.5937 241.126C98.2834 239.704 103.315 233.896 105.21 227.378C105.979 224.77 106.335 221.807 105.447 219.141L99.645 216.77Z",
    fill: "#0D0B0A"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M218.521 221.749C218.521 221.749 190.815 183.052 175.66 172.8L186.967 156.919C203.662 168.237 234.683 210.608 234.683 210.608L218.521 221.749Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 156,
    width: 60,
    height: 66
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M218.521 221.749C218.521 221.749 190.815 183.052 175.66 172.8L186.967 156.919C203.662 168.237 234.683 210.608 234.683 210.608L218.521 221.749Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.912 227.319C214.912 227.319 177.26 181.571 162.164 171.378L170.926 162.489C187.62 173.808 223.141 220.504 223.141 220.504L214.912 227.319Z",
    fill: "#D0D0D0"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M234.443 210.37C248.888 218.192 248.651 238.163 235.154 237.511C230.477 237.274 224.971 231.229 223.254 226.785C223.314 228.563 222.544 233.007 219.821 231.526C218.755 230.933 217.512 226.548 218.341 221.392C221.893 216 229.293 210.429 234.443 210.37Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 210,
    width: 28,
    height: 28
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M234.443 210.37C248.888 218.192 248.651 238.163 235.154 237.511C230.477 237.274 224.971 231.229 223.254 226.785C223.314 228.563 222.544 233.007 219.821 231.526C218.755 230.933 217.512 226.548 218.341 221.392C221.893 216 229.293 210.429 234.443 210.37Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.355 216.77C220.237 216.652 224.322 220.622 225.565 223.881C230.419 235.615 241.845 240.118 246.7 227.318C246.108 238.281 234.8 242.429 228.407 241.126C221.717 239.704 216.685 233.896 214.791 227.378C214.021 224.77 213.666 221.807 214.554 219.141L220.355 216.77Z",
    fill: "#0D0B0A"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.926H127.114C119.537 183.526 113.676 208.948 113.676 226.252C113.676 256.711 134.337 272.592 159.911 272.592C185.486 272.592 206.325 256.77 206.325 226.252C206.325 209.007 200.464 183.585 192.886 157.926Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.926H127.114C119.537 183.526 113.676 208.948 113.676 226.252C113.676 256.711 134.337 272.592 159.911 272.592C185.486 272.592 206.325 256.77 206.325 226.252C206.325 209.007 200.464 183.585 192.886 157.926Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.798 157.926H127.114C119.537 183.526 113.676 208.948 113.676 226.252C113.676 239.763 117.761 252.148 124.569 261.748C120.721 253.096 118.53 243.141 118.53 232.533C118.53 215.348 124.095 184.652 132.798 157.926Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.926H127.114C119.537 183.526 113.676 208.948 113.676 226.252C113.676 256.711 134.337 272.592 159.911 272.592C185.486 272.592 206.325 256.77 206.325 226.252C206.325 209.007 200.464 183.585 192.886 157.926Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.203 157.926H192.886C200.464 183.526 206.325 208.948 206.325 226.252C206.325 239.763 202.24 252.148 195.432 261.748C199.28 253.096 201.47 243.141 201.47 232.533C201.47 215.348 195.906 184.652 187.203 157.926Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.926H127.114C119.537 183.526 113.676 208.948 113.676 226.252C113.676 256.711 134.337 272.592 159.911 272.592C185.486 272.592 206.325 256.77 206.325 226.252C206.325 209.007 200.464 183.585 192.886 157.926Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.884 144.178C178.561 163.378 185.546 202.43 185.546 215.644C185.546 234.904 174.831 246.933 160.09 246.933C145.349 246.933 134.16 234.904 134.16 215.644C134.16 202.43 141.087 163.378 145.763 144.178H173.884Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.926H127.114C119.537 183.526 113.676 208.948 113.676 226.252C113.676 256.711 134.337 272.592 159.911 272.592C185.486 272.592 206.325 256.77 206.325 226.252C206.325 209.007 200.464 183.585 192.886 157.926Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.225 214.34C218.815 215.525 226.452 217.777 226.215 219.377C226.038 220.977 218.105 221.333 208.514 220.088C198.924 218.903 191.287 216.651 191.524 215.051C191.701 213.451 199.634 213.155 209.225 214.34ZM208.692 201.422C218.342 200.711 226.215 201.422 226.334 203.022C226.452 204.622 218.756 206.518 209.106 207.229C199.457 207.94 191.583 207.229 191.465 205.629C191.346 204.088 199.042 202.192 208.692 201.422ZM207.626 187.555C217.039 185.422 224.972 185.007 225.327 186.548C225.682 188.088 218.342 191.111 208.869 193.244C199.457 195.377 191.524 195.792 191.169 194.251C190.813 192.651 198.213 189.688 207.626 187.555Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 185,
    width: 16,
    height: 36
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 185,
    width: 36,
    height: 36
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M209.225 214.341C218.815 215.526 226.452 217.778 226.215 219.378C226.038 220.978 218.105 221.334 208.514 220.089C198.924 218.904 191.287 216.652 191.524 215.052C191.701 213.452 199.634 213.156 209.225 214.341ZM208.692 201.423C218.342 200.711 226.215 201.423 226.334 203.023C226.452 204.623 218.756 206.519 209.106 207.23C199.457 207.941 191.583 207.23 191.465 205.63C191.346 204.089 199.042 202.193 208.692 201.423ZM207.626 187.556C217.039 185.423 224.972 185.008 225.327 186.549C225.682 188.089 218.342 191.111 208.869 193.245C199.457 195.378 191.524 195.793 191.169 194.252C190.813 192.652 198.213 189.689 207.626 187.556Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.927H127.114C119.537 183.527 113.676 208.949 113.676 226.253C113.676 256.712 134.337 272.593 159.911 272.593C185.486 272.593 206.325 256.771 206.325 226.253C206.325 209.008 200.464 183.586 192.886 157.927Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.203 157.927H192.886C200.464 183.527 206.325 208.949 206.325 226.253C206.325 239.764 202.24 252.149 195.432 261.749C199.28 253.097 201.47 243.142 201.47 232.534C201.47 215.349 195.906 184.653 187.203 157.927Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.926H127.114C119.537 183.526 113.676 208.948 113.676 226.252C113.676 256.711 134.337 272.592 159.911 272.592C185.486 272.592 206.325 256.77 206.325 226.252C206.325 209.007 200.464 183.585 192.886 157.926Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.36 214.34C100.77 215.525 93.1329 217.777 93.3697 219.377C93.5474 220.977 101.48 221.333 111.071 220.088C120.661 218.903 128.298 216.651 128.061 215.051C127.884 213.451 119.951 213.155 110.36 214.34ZM110.893 201.422C101.243 200.711 93.3697 201.422 93.2513 203.022C93.1329 204.622 100.829 206.518 110.479 207.229C120.128 207.94 128.002 207.229 128.12 205.629C128.239 204.088 120.484 202.192 110.893 201.422ZM111.959 187.555C102.546 185.422 94.613 185.007 94.2578 186.548C93.9026 188.088 101.243 191.111 110.715 193.244C120.128 195.377 128.061 195.792 128.416 194.251C128.712 192.651 121.372 189.688 111.959 187.555Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 185,
    width: 16,
    height: 36
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 185,
    width: 36,
    height: 36
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M110.36 214.341C100.77 215.526 93.1329 217.778 93.3697 219.378C93.5474 220.978 101.48 221.334 111.071 220.089C120.661 218.904 128.298 216.652 128.061 215.052C127.884 213.452 119.951 213.156 110.36 214.341ZM110.893 201.423C101.243 200.711 93.3697 201.423 93.2513 203.023C93.1329 204.623 100.829 206.519 110.479 207.23C120.128 207.941 128.002 207.23 128.12 205.63C128.239 204.089 120.484 202.193 110.893 201.423ZM111.959 187.556C102.546 185.423 94.613 185.008 94.2578 186.549C93.9026 188.089 101.243 191.111 110.715 193.245C120.128 195.378 128.061 195.793 128.416 194.252C128.712 192.652 121.372 189.689 111.959 187.556Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.886 157.927H127.114C119.537 183.527 113.676 208.949 113.676 226.253C113.676 256.712 134.337 272.593 159.911 272.593C185.486 272.593 206.325 256.771 206.325 226.253C206.325 209.008 200.464 183.586 192.886 157.927Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.798 157.927H127.114C119.537 183.527 113.676 208.949 113.676 226.253C113.676 239.764 117.761 252.149 124.569 261.749C120.721 253.097 118.53 243.142 118.53 232.534C118.53 215.349 124.095 184.653 132.798 157.927Z",
    fill: "#666460"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M236.16 24.1775C237.404 24.4145 238.292 25.5997 238.173 26.8442C236.575 44.9182 217.867 60.859 199.989 58.5479L193.832 51.5553C197.68 30.8145 218.045 20.5034 236.16 24.1775Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 23,
    width: 46,
    height: 36
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M236.16 24.1775C237.404 24.4145 238.292 25.5997 238.173 26.8442C236.575 44.9182 217.867 60.859 199.989 58.5479L193.832 51.5553C197.68 30.8145 218.045 20.5034 236.16 24.1775Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.777 45.5111L198.981 40C198.981 40 205.552 42.963 213.248 50.6074C214.61 51.9704 216.741 52.2667 218.458 51.3778C224.259 48.1778 236.573 39.763 240.184 24C240.184 24 240.066 52.6222 210.347 62.3407C210.288 62.4 207.209 52.8 194.777 45.5111Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 23,
    width: 46,
    height: 36
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M236.16 24.1775C237.404 24.4145 238.292 25.5997 238.173 26.8442C236.575 44.9182 217.867 60.859 199.989 58.5479L193.832 51.5553C197.68 30.8145 218.045 20.5034 236.16 24.1775Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.449 49.8365C198.449 49.8365 205.553 32.8883 226.451 33.8957C226.925 33.8957 227.339 34.1328 227.635 34.4883C227.931 34.8439 227.99 35.318 227.872 35.792C226.51 40.4143 221.478 52.5031 205.02 54.5772L198.449 49.8365Z",
    fill: "#F7D8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 33,
    width: 30,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 33,
    width: 30,
    height: 22
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M198.449 49.8375C198.449 49.8375 205.553 32.8893 226.451 33.8967C226.925 33.8967 227.339 34.1337 227.635 34.4893C227.931 34.8449 227.99 35.3189 227.872 35.793C226.51 40.4152 221.478 52.5041 205.02 54.5782L198.449 49.8375Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.16 24.1785C237.404 24.4155 238.292 25.6007 238.173 26.8451C236.575 44.9192 217.867 60.86 199.989 58.5488L193.832 51.5563C197.68 30.8155 218.045 20.5044 236.16 24.1785Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.777 45.5111L198.981 40C198.981 40 205.552 42.963 213.248 50.6074C214.61 51.9704 216.741 52.2667 218.458 51.3778C224.259 48.1778 236.573 39.763 240.184 24C240.184 24 240.066 52.6222 210.347 62.3407C210.288 62.4 207.209 52.8 194.777 45.5111Z",
    fill: "#F0BA9E"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8398 24.1775C82.5966 24.4145 81.7086 25.5997 81.827 26.8442C83.4254 44.9182 102.133 60.859 120.011 58.5479L126.168 51.5553C122.32 30.8145 101.955 20.5034 83.8398 24.1775Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 23,
    width: 46,
    height: 36
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8398 24.1775C82.5966 24.4145 81.7086 25.5997 81.827 26.8442C83.4254 44.9182 102.133 60.859 120.011 58.5479L126.168 51.5553C122.32 30.8145 101.955 20.5034 83.8398 24.1775Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.219 45.5111L121.016 40C121.016 40 114.445 42.963 106.749 50.6074C105.387 51.9704 103.256 52.2667 101.539 51.3778C95.7374 48.1778 83.4237 39.763 79.8125 24C79.8125 24 79.9309 52.6222 109.65 62.3407C109.709 62.4 112.787 52.8 125.219 45.5111Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 23,
    width: 46,
    height: 36
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8398 24.1775C82.5966 24.4145 81.7086 25.5997 81.827 26.8442C83.4254 44.9182 102.133 60.859 120.011 58.5479L126.168 51.5553C122.32 30.8145 101.955 20.5034 83.8398 24.1775Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.609 49.8365C121.609 49.8365 114.505 32.8883 93.6069 33.8957C93.1333 33.8957 92.7189 34.1328 92.4229 34.4883C92.1269 34.8439 92.0677 35.318 92.1861 35.792C93.5477 40.4143 98.5797 52.5031 115.037 54.5772L121.609 49.8365Z",
    fill: "#F7D8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 33,
    width: 30,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 33,
    width: 30,
    height: 22
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.609 49.8375C121.609 49.8375 114.505 32.8893 93.6069 33.8967C93.1333 33.8967 92.7189 34.1337 92.4229 34.4893C92.1269 34.8449 92.0677 35.3189 92.1861 35.793C93.5477 40.4152 98.5797 52.5041 115.037 54.5782L121.609 49.8375Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8398 24.1785C82.5966 24.4155 81.7086 25.6007 81.827 26.8451C83.4254 44.9192 102.133 60.86 120.011 58.5488L126.168 51.5563C122.32 30.8155 101.955 20.5044 83.8398 24.1785Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.219 45.5111L121.016 40C121.016 40 114.445 42.963 106.749 50.6074C105.387 51.9704 103.256 52.2667 101.539 51.3778C95.7374 48.1778 83.4237 39.763 79.8125 24C79.8125 24 79.9309 52.6222 109.65 62.3407C109.709 62.4 112.787 52.8 125.219 45.5111Z",
    fill: "#F0BA9E"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M159.732 178.252C136.822 177.659 104.025 165.63 95.7365 112.237C90.1717 76.3851 104.321 46.7555 131.553 33.7777C154.108 22.8148 176.96 26.3111 190.221 34.6073C216.269 47.9999 229.766 77.0962 224.32 112.237C215.973 165.807 182.939 177.718 160.028 178.252H159.732Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 26,
    width: 132,
    height: 153
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M159.732 178.252C136.822 177.659 104.025 165.63 95.7365 112.237C90.1717 76.3851 104.321 46.7555 131.553 33.7777C154.108 22.8148 176.96 26.3111 190.221 34.6073C216.269 47.9999 229.766 77.0962 224.32 112.237C215.973 165.807 182.939 177.718 160.028 178.252H159.732Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1094 69.8669C104.97 53.8077 116.159 41.1262 131.551 33.8373C154.107 22.8743 176.958 26.3706 190.219 34.6669C204.723 42.1336 215.261 54.4003 220.885 69.8669C214.846 56.1188 204.545 45.1558 190.929 38.341C177.313 30.0447 153.929 26.5484 130.782 37.5114C116.278 44.2077 105.385 55.5262 99.1094 69.8669Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 26,
    width: 132,
    height: 153
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M159.732 178.252C136.822 177.659 104.025 165.63 95.7365 112.237C90.1717 76.3851 104.321 46.7555 131.553 33.7777C154.108 22.8148 176.96 26.3111 190.221 34.6073C216.269 47.9999 229.766 77.0962 224.32 112.237C215.973 165.807 182.939 177.718 160.028 178.252H159.732Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0314 80.9482C94.9066 89.3038 94.9658 98.3112 96.4458 107.793C104.615 161.185 137.116 173.156 159.731 173.807H159.968C182.642 173.274 215.32 161.363 223.549 107.793C224.97 98.3705 225.088 89.3631 223.964 80.9482C225.858 90.5482 226.036 101.096 224.26 112.237C215.912 165.807 182.878 177.719 159.968 178.252H159.672C136.761 177.659 103.964 165.63 95.6762 112.237C93.9593 101.096 94.1369 90.6075 96.0314 80.9482Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 26,
    width: 132,
    height: 153
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M159.732 178.252C136.822 177.659 104.025 165.63 95.7365 112.237C90.1717 76.3851 104.321 46.7555 131.553 33.7777C154.108 22.8148 176.96 26.3111 190.221 34.6073C216.269 47.9999 229.766 77.0962 224.32 112.237C215.973 165.807 182.939 177.718 160.028 178.252H159.732Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.635 148.503C236.102 149.57 228.346 146.844 219.23 142.459C210.113 138.074 203.127 133.629 203.66 132.622C204.193 131.555 211.948 134.281 221.065 138.666C230.182 143.052 237.167 147.437 236.635 148.503ZM83.3645 148.503C83.8973 149.57 91.6525 146.844 100.769 142.459C109.886 138.074 116.872 133.629 116.339 132.622C115.806 131.555 108.051 134.281 98.9342 138.666C89.8173 142.992 82.8317 147.437 83.3645 148.503ZM238.943 142.518C238.351 143.703 229.708 140.681 219.644 135.822C209.58 130.963 201.825 126.044 202.357 124.859C202.949 123.674 211.593 126.696 221.657 131.555C231.78 136.474 239.476 141.333 238.943 142.518ZM81.0556 142.518C81.6476 143.703 90.2909 140.681 100.355 135.822C110.419 130.963 118.174 126.044 117.642 124.859C117.05 123.674 108.406 126.696 98.3422 131.555C88.2189 136.474 80.5228 141.333 81.0556 142.518ZM243.679 137.718C243.147 138.785 235.391 136.059 226.274 131.674C217.158 127.289 210.172 122.844 210.705 121.837C211.238 120.77 218.993 123.496 228.11 127.881C237.227 132.207 244.212 136.652 243.679 137.718ZM76.3196 137.718C76.8524 138.785 84.6077 136.059 93.7245 131.674C102.841 127.289 109.827 122.844 109.294 121.837C108.761 120.77 101.006 123.496 91.8893 127.881C82.8317 132.207 75.846 136.652 76.3196 137.718Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 121,
    width: 132,
    height: 28
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 121,
    width: 168,
    height: 28
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M236.635 148.503C236.102 149.57 228.346 146.844 219.23 142.459C210.113 138.074 203.127 133.629 203.66 132.622C204.193 131.555 211.948 134.281 221.065 138.666C230.182 143.052 237.167 147.437 236.635 148.503ZM83.3645 148.503C83.8973 149.57 91.6525 146.844 100.769 142.459C109.886 138.074 116.872 133.629 116.339 132.622C115.806 131.555 108.051 134.281 98.9342 138.666C89.8173 142.992 82.8317 147.437 83.3645 148.503ZM238.943 142.518C238.351 143.703 229.708 140.681 219.644 135.822C209.58 130.963 201.825 126.044 202.357 124.859C202.949 123.674 211.593 126.696 221.657 131.555C231.78 136.474 239.476 141.333 238.943 142.518ZM81.0556 142.518C81.6476 143.703 90.2909 140.681 100.355 135.822C110.419 130.963 118.174 126.044 117.642 124.859C117.05 123.674 108.406 126.696 98.3422 131.555C88.2189 136.474 80.5228 141.333 81.0556 142.518ZM243.679 137.718C243.147 138.785 235.391 136.059 226.274 131.674C217.158 127.289 210.172 122.844 210.705 121.837C211.238 120.77 218.993 123.496 228.11 127.881C237.227 132.207 244.212 136.652 243.679 137.718ZM76.3196 137.718C76.8524 138.785 84.6077 136.059 93.7245 131.674C102.841 127.289 109.827 122.844 109.294 121.837C108.761 120.77 101.006 123.496 91.8893 127.881C82.8317 132.207 75.846 136.652 76.3196 137.718Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.732 178.252C136.822 177.659 104.025 165.63 95.7365 112.237C90.1717 76.3851 104.321 46.7555 131.553 33.7777C154.108 22.8148 176.96 26.3111 190.221 34.6073C216.269 47.9999 229.766 77.0962 224.32 112.237C215.973 165.807 182.939 177.718 160.028 178.252H159.732Z",
    fill: "white"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0353 80.9482C94.9105 89.3038 94.9697 98.3112 96.4497 107.793C104.619 161.185 137.12 173.156 159.735 173.807H159.972C182.646 173.274 215.324 161.363 223.553 107.793C224.974 98.3705 225.092 89.3631 223.968 80.9482C225.862 90.5482 226.04 101.096 224.264 112.237C215.916 165.807 182.882 177.719 159.972 178.252H159.676C136.765 177.659 103.968 165.63 95.6801 112.237C93.9633 101.096 94.1409 90.6075 96.0353 80.9482Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 26,
    width: 132,
    height: 153
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M159.732 178.252C136.822 177.659 104.025 165.63 95.7365 112.237C90.1717 76.3851 104.321 46.7555 131.553 33.7777C154.108 22.8148 176.96 26.3111 190.221 34.6073C216.269 47.9999 229.766 77.0962 224.32 112.237C215.973 165.807 182.939 177.718 160.028 178.252H159.732Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.348 25.3033C211.532 26.1329 207.743 33.3033 201.882 41.244C196.022 49.1847 190.338 54.9329 189.214 54.044C188.03 53.2144 191.818 46.044 197.679 38.1033C203.481 30.2218 209.164 24.4736 210.348 25.3033ZM109.648 25.3033C108.464 26.1329 112.253 33.3033 118.114 41.244C123.975 49.1847 129.658 54.9329 130.783 54.044C131.967 53.2144 128.178 46.044 122.317 38.1033C116.515 30.2218 110.832 24.4736 109.648 25.3033ZM218.281 35.9699C218.991 36.9181 214.551 41.6588 208.276 46.5773C202.001 51.4959 196.377 54.7551 195.607 53.807C194.897 52.8588 199.337 48.1181 205.612 43.1996C211.887 38.2218 217.571 35.0218 218.281 35.9699ZM101.715 35.9699C101.005 36.9181 105.445 41.6588 111.72 46.5773C117.995 51.4959 123.679 54.7551 124.389 53.807C125.099 52.8588 120.659 48.1181 114.384 43.1996C108.168 38.2218 102.485 35.0218 101.715 35.9699ZM196.081 21.8662C197.206 22.281 195.962 28.681 193.298 36.207C190.634 43.7329 187.615 49.481 186.431 49.1255C185.306 48.7107 186.55 42.3107 189.214 34.7847C191.878 27.2588 194.956 21.5107 196.081 21.8662ZM123.975 21.8662C122.85 22.281 124.093 28.681 126.757 36.207C129.421 43.7329 132.44 49.481 133.624 49.1255C134.749 48.7107 133.506 42.3107 130.842 34.7847C128.119 27.2588 125.099 21.5107 123.975 21.8662Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 26,
    width: 118,
    height: 29
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 21,
    width: 118,
    height: 34
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M210.348 25.3042C211.532 26.1339 207.743 33.3042 201.882 41.245C196.022 49.1857 190.338 54.9339 189.214 54.045C188.03 53.2154 191.818 46.045 197.679 38.1042C203.481 30.2228 209.164 24.4746 210.348 25.3042ZM109.648 25.3042C108.464 26.1339 112.253 33.3042 118.114 41.245C123.975 49.1857 129.658 54.9339 130.783 54.045C131.967 53.2154 128.178 46.045 122.317 38.1042C116.515 30.2228 110.832 24.4746 109.648 25.3042ZM218.281 35.9709C218.991 36.9191 214.551 41.6598 208.276 46.5783C202.001 51.4968 196.377 54.7561 195.607 53.8079C194.897 52.8598 199.337 48.1191 205.612 43.2005C211.887 38.2228 217.571 35.0228 218.281 35.9709ZM101.715 35.9709C101.005 36.9191 105.445 41.6598 111.72 46.5783C117.995 51.4968 123.679 54.7561 124.389 53.8079C125.099 52.8598 120.659 48.1191 114.384 43.2005C108.168 38.2228 102.485 35.0228 101.715 35.9709ZM196.081 21.8672C197.206 22.282 195.962 28.682 193.298 36.2079C190.634 43.7339 187.615 49.482 186.431 49.1265C185.306 48.7117 186.55 42.3116 189.214 34.7857C191.878 27.2598 194.956 21.5116 196.081 21.8672ZM123.975 21.8672C122.85 22.282 124.093 28.682 126.757 36.2079C129.421 43.7339 132.44 49.482 133.624 49.1265C134.749 48.7117 133.506 42.3116 130.842 34.7857C128.119 27.2598 125.099 21.5116 123.975 21.8672Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.732 178.253C136.822 177.66 104.025 165.631 95.7365 112.238C90.1717 76.3861 104.321 46.7565 131.553 33.7787C154.108 22.8157 176.96 26.312 190.221 34.6083C216.269 48.0009 229.766 77.0972 224.32 112.238C215.973 165.808 182.939 177.719 160.028 178.253H159.732Z",
    fill: "white"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1094 69.8669C104.97 53.8077 116.159 41.1262 131.551 33.8373C154.107 22.8743 176.958 26.3706 190.219 34.6669C204.723 42.1336 215.261 54.4003 220.885 69.8669C214.846 56.1188 204.545 45.1558 190.929 38.341C177.313 30.0447 153.929 26.5484 130.782 37.5114C116.278 44.2077 105.385 55.5262 99.1094 69.8669Z",
    fill: "#666460"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.03 117.748C183.947 117.748 203.365 132.918 203.365 151.585C203.365 170.252 187.617 185.422 160.03 185.422C132.443 185.422 116.695 170.252 116.695 151.585C116.695 132.918 136.113 117.748 160.03 117.748Z",
    fill: "#9A9895"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.906 135.467C129.247 124.918 143.574 117.748 160.031 117.748C176.489 117.748 190.816 124.918 198.156 135.467C189.572 127.052 175.719 121.541 160.031 121.541C144.343 121.541 130.49 127.052 121.906 135.467Z",
    fill: "#C1BFBD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.812 154.607C121.193 168.948 136.349 179.496 159.97 179.496C183.591 179.496 198.746 168.948 203.127 154.607C201.528 171.911 186.018 185.482 159.97 185.482C133.921 185.422 118.411 171.852 116.812 154.607Z",
    fill: "#64615E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.375 119.822C189.809 120.948 191.525 124.622 190.223 128.118C188.921 131.614 185.073 133.57 181.639 132.444C178.205 131.318 176.489 127.644 177.791 124.148C179.093 120.652 183.001 118.755 186.375 119.822Z",
    fill: "#9A9895"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.952 123.437C186.965 124.089 187.971 126.282 187.261 128.296C186.491 130.311 183.709 132.385 181.341 131.556C182.347 129.126 180.038 129.304 180.453 126.459C180.808 124.326 182.939 122.785 184.952 123.437Z",
    fill: "#2F2D2A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.627 119.822C130.194 120.948 128.477 124.622 129.779 128.118C131.082 131.614 134.93 133.57 138.363 132.444C141.797 131.318 143.514 127.644 142.211 124.148C140.85 120.652 137.061 118.755 133.627 119.822Z",
    fill: "#9A9895"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.048 123.437C133.035 124.089 132.029 126.282 132.739 128.296C133.509 130.311 136.291 132.385 138.659 131.556C137.653 129.126 139.961 129.304 139.547 126.459C139.192 124.326 137.061 122.785 135.048 123.437Z",
    fill: "#2F2D2A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.107 72.0596C144.046 72.0596 151.269 79.4077 151.269 88.4744C151.269 97.5411 144.046 104.889 135.107 104.889C126.168 104.889 118.945 97.5411 118.945 88.4744C118.945 79.4077 126.227 72.0596 135.107 72.0596Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.105 77.6895C141.617 77.6895 146.886 83.0228 146.886 89.6006C146.886 96.1783 141.617 101.512 135.105 101.512C128.593 101.512 123.324 96.1783 123.324 89.6006C123.383 83.0228 128.652 77.6895 135.105 77.6895Z",
    fill: "#0D0B0A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.533 81.1851C138.421 80.5333 140.197 81.4814 141.559 83.3185C142.92 85.1555 143.335 87.1703 142.447 87.8222C141.559 88.474 139.783 87.5259 138.421 85.6888C137.059 83.9111 136.704 81.837 137.533 81.1851Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.745 89.8369C143.751 89.8369 144.521 90.6665 144.521 91.6147C144.521 92.5628 143.751 93.3925 142.745 93.3925C141.738 93.3925 140.969 92.5628 140.969 91.6147C140.969 90.6665 141.798 89.8369 142.745 89.8369Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.892 72.0596C193.831 72.0596 201.054 79.4077 201.054 88.4744C201.054 97.5411 193.831 104.889 184.892 104.889C175.953 104.889 168.73 97.5411 168.73 88.4744C168.73 79.4077 175.953 72.0596 184.892 72.0596Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.894 77.6895C191.406 77.6895 196.675 83.0228 196.675 89.6006C196.675 96.1783 191.406 101.512 184.894 101.512C178.382 101.512 173.113 96.1783 173.113 89.6006C173.113 83.0228 178.382 77.6895 184.894 77.6895Z",
    fill: "#0D0B0A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.322 81.1851C188.21 80.5333 189.986 81.4814 191.348 83.3185C192.709 85.1555 193.124 87.1703 192.236 87.8222C191.348 88.474 189.572 87.5259 188.21 85.6888C186.848 83.9111 186.493 81.837 187.322 81.1851Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.53 89.8369C193.536 89.8369 194.306 90.6665 194.306 91.6147C194.306 92.5628 193.536 93.3925 192.53 93.3925C191.524 93.3925 190.754 92.5628 190.754 91.6147C190.754 90.6665 191.583 89.8369 192.53 89.8369Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.681 107.378C119.772 107.378 123.916 109.333 123.916 111.763C123.916 114.193 119.772 116.148 114.681 116.148C109.59 116.148 105.446 114.193 105.446 111.763C105.387 109.333 109.531 107.378 114.681 107.378Z",
    fill: "#ED8181"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.317 107.378C210.409 107.378 214.553 109.333 214.553 111.763C214.553 114.193 210.409 116.148 205.317 116.148C200.226 116.148 196.082 114.193 196.082 111.763C196.082 109.333 200.226 107.378 205.317 107.378Z",
    fill: "#ED8181"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M185.724 36.5631C180.573 27.7927 175.127 21.5112 166.661 18.4298C166.543 18.3705 166.365 18.4298 166.247 18.5483C166.128 18.6668 166.128 18.8446 166.247 18.9631C167.016 20.1483 168.378 22.4001 169.917 25.4816C166.543 24.1187 155.946 12.3261 155.591 5.92606C155.591 5.74828 155.531 5.5705 155.354 5.51124C155.176 5.45198 154.999 5.45198 154.88 5.51124C152.453 8.29643 149.138 17.9557 151.269 25.2446C151.269 25.2446 144.461 23.5853 139.074 15.5261C138.896 15.289 138.659 15.1705 138.363 15.1705C138.067 15.1705 137.831 15.3483 137.712 15.5853C136.232 19.6149 137.831 29.7483 143.81 35.0816L185.724 36.5631Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 5,
    width: 49,
    height: 32
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M185.724 36.5631C180.573 27.7927 175.127 21.5112 166.661 18.4298C166.543 18.3705 166.365 18.4298 166.247 18.5483C166.128 18.6668 166.128 18.8446 166.247 18.9631C167.016 20.1483 168.378 22.4001 169.917 25.4816C166.543 24.1187 155.946 12.3261 155.591 5.92606C155.591 5.74828 155.531 5.5705 155.354 5.51124C155.176 5.45198 154.999 5.45198 154.88 5.51124C152.453 8.29643 149.138 17.9557 151.269 25.2446C151.269 25.2446 144.461 23.5853 139.074 15.5261C138.896 15.289 138.659 15.1705 138.363 15.1705C138.067 15.1705 137.831 15.3483 137.712 15.5853C136.232 19.6149 137.831 29.7483 143.81 35.0816L185.724 36.5631Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.772 17.8961C165.772 17.8961 166.009 18.2516 166.009 18.3109C166.305 18.7257 166.601 19.1998 166.897 19.6146C168.2 21.4516 169.68 23.2887 171.219 24.8887C171.692 25.3628 172.107 25.8368 172.58 26.2516C172.64 26.3109 172.995 26.6072 172.936 26.7257C172.758 26.9035 171.456 26.1924 171.278 26.1331C169.502 25.3035 168.022 24.1776 166.66 22.7554C164.233 20.1479 162.279 17.1257 160.503 14.0442C158.609 10.6665 156.833 6.87387 156.478 2.96276C156.478 2.84424 156.182 3.08128 156.123 3.08128C155.886 3.1998 155.649 3.37757 155.412 3.49609C154.82 3.91091 154.228 4.5035 153.695 5.03683C152.097 6.81461 150.854 9.0072 150.38 11.3776C149.611 15.4665 150.321 20.622 152.63 24.1183C154.051 26.2516 156.063 27.7924 158.254 28.9776C158.195 28.9183 157.839 28.8591 157.78 28.7998C157.307 28.622 156.892 28.4442 156.419 28.2665C154.879 27.6146 153.34 26.9035 151.919 26.0739C148.19 23.9405 145.467 20.9776 143.454 17.2442C143.513 17.3035 143.395 17.1257 143.335 17.0072C143.217 16.8887 143.158 16.7109 143.039 16.5331C142.802 16.1183 142.506 15.7035 142.27 15.2887C141.678 14.3405 140.553 11.8516 139.191 11.9702C138.422 12.0294 137.711 12.6813 137.238 13.2146C135.876 14.8146 135.462 17.2442 135.521 19.2591C135.58 21.2146 136.468 22.9331 137.415 24.6516C138.777 27.0813 140.257 29.5109 142.329 31.3479C143.395 32.3554 144.579 33.1257 145.881 33.8368C146.295 34.0739 146.71 34.3109 147.183 34.4887C147.243 34.4887 147.835 34.7257 147.835 34.785C147.775 34.8442 147.42 34.785 147.361 34.785C146.887 34.785 146.414 34.785 145.999 34.785C143.927 34.7257 141.914 34.2516 140.138 33.0665C136.705 30.8146 134.337 26.8442 132.679 23.1702C131.673 20.9183 130.903 18.4887 131.318 16.0591C132.738 7.11091 141.441 0.651649 150.143 0.059056C158.313 -0.474277 167.015 4.85906 167.607 13.6294L165.772 17.8961Z",
    fill: "#D0D0D0"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M140.909 150.992C140.258 150.933 139.548 151.17 139.074 151.644C138.601 152.118 138.364 152.77 138.423 153.481C139.844 163.733 148.842 171.674 159.735 171.674C170.628 171.674 179.686 163.733 181.047 153.481C181.107 152.829 180.929 152.178 180.455 151.703C179.982 151.229 179.331 150.992 178.679 151.052C169.444 151.703 150.026 151.703 140.909 150.992Z",
    fill: "#0D0B0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 150,
    width: 44,
    height: 22
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M140.909 150.992C140.258 150.933 139.548 151.17 139.074 151.644C138.601 152.118 138.364 152.77 138.423 153.481C139.844 163.733 148.842 171.674 159.735 171.674C170.628 171.674 179.686 163.733 181.047 153.481C181.107 152.829 180.929 152.178 180.455 151.703C179.982 151.229 179.331 150.992 178.679 151.052C169.444 151.703 150.026 151.703 140.909 150.992Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.329 162.192C170.689 162.192 179.096 170.607 179.096 181.037C179.096 191.407 170.689 199.881 160.329 199.881C149.969 199.881 141.562 191.466 141.562 181.037C141.562 170.607 149.969 162.192 160.329 162.192Z",
    fill: "#FF0010"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_198_189850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 150,
    width: 44,
    height: 22
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M140.909 150.992C140.258 150.933 139.548 151.17 139.074 151.644C138.601 152.118 138.364 152.77 138.423 153.481C139.844 163.733 148.842 171.674 159.735 171.674C170.628 171.674 179.686 163.733 181.047 153.481C181.107 152.829 180.929 152.178 180.455 151.703C179.982 151.229 179.331 150.992 178.679 151.052C169.444 151.703 150.026 151.703 140.909 150.992Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_198_189850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.652 143.703H145.052C144.875 148.029 144.401 152.414 146.059 156.148C146.355 156.74 146.887 157.155 147.539 157.333C156.715 159.348 162.872 159.407 171.692 157.392C172.344 157.214 172.876 156.799 173.172 156.207C175.067 151.881 174.712 147.792 174.652 143.703Z",
    fill: "white"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M159.791 173.096C148.306 173.096 138.479 164.741 136.999 153.6C136.88 152.474 137.236 151.348 138.064 150.519C138.834 149.748 139.959 149.333 141.084 149.452C150.023 150.163 169.322 150.222 178.617 149.452C179.682 149.333 180.807 149.689 181.577 150.519C182.346 151.348 182.761 152.415 182.583 153.541C181.103 164.741 171.276 173.096 159.791 173.096ZM140.669 152.415C140.492 152.415 140.314 152.474 140.136 152.652C139.959 152.83 139.9 153.007 139.959 153.245C141.261 162.845 149.786 170.133 159.85 170.133C169.855 170.133 178.439 162.845 179.682 153.185C179.682 153.007 179.623 152.77 179.505 152.652C179.327 152.474 179.15 152.415 178.913 152.474C169.441 153.244 149.904 153.244 140.847 152.474H140.788C140.728 152.415 140.669 152.415 140.669 152.415Z",
    fill: "#0D0B0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_189850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 320,
    fill: "white",
    transform: "translate(63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZebraHappy);
export default __webpack_public_path__ + "static/media/zebra_happy.c4d4e662935e73c0bbdce24faf69f6da.svg";
export { ForwardRef as ReactComponent };